var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"l-autobuyers-tab"},[_vm._l((_vm.multiple),function(type,id){return _c('MultipleAutobuyersBox',{key:id,attrs:{"type":type}})}),_c('MultipleSingleAutobuyersGroup')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }